import { TYPES } from './reducer';

function actions(dispatch) {
  return {
    createInput() {
      dispatch({
        type: TYPES.CREATE_INPUT
      });
    },
    deleteInput(index) {
      dispatch({
        type: TYPES.DELETE_INPUT,
        payload: {
          index,
          arrayIndexes: index
        }
      });
    },
    selectTag(tag) {
      dispatch({
        type: TYPES.SELECT_TAG,
        payload: {
          tag
        }
      });
    },
    editValue(index, value) {
      dispatch({
        type: TYPES.EDIT_VALUE,
        payload: {
          index,
          value
        }
      });
    }
  };
}

export default actions;
